/**
 * Zoom presets for the document toolbar's percentage picker.
 *
 * Figma 95:14665 renders the readout as "100% ›" — the chevron promises a list,
 * so the readout is a real picker rather than a label that only looks tappable.
 * Kept out of the toolbar module so that file exports components only.
 */
export const ZOOM_PRESETS = [0.5, 0.75, 1, 1.25, 1.5, 2, 3];

/** `1` → `"100%"`. */
export const toZoomPercent = (zoom: number) => `${Math.round(zoom * 100)}%`;

/** Whether a scale is the given preset, allowing for float drift from stepping. */
export const isZoomPreset = (zoom: number, preset: number) =>
  Math.abs(preset - zoom) < 0.005;
